"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports["default"] = void 0

var _gatsby = require("gatsby")

var _propTypes = _interopRequireDefault(require("prop-types"))

var _react = _interopRequireDefault(require("react"))

var _reactFontawesome = require("@fortawesome/react-fontawesome")

var _faLongArrowLeft = require("@fortawesome/pro-light-svg-icons/faLongArrowLeft")

var _faFileDownload = require("@fortawesome/pro-solid-svg-icons/faFileDownload")

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _typeof(obj) {
  "@babel/helpers - typeof"
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj
    }
  }
  return _typeof(obj)
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function")
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i]
    descriptor.enumerable = descriptor.enumerable || false
    descriptor.configurable = true
    if ("value" in descriptor) descriptor.writable = true
    Object.defineProperty(target, descriptor.key, descriptor)
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps)
  if (staticProps) _defineProperties(Constructor, staticProps)
  return Constructor
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function")
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true }
  })
  if (superClass) _setPrototypeOf(subClass, superClass)
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p
      return o
    }
  return _setPrototypeOf(o, p)
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
      result
    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor
      result = Reflect.construct(Super, arguments, NewTarget)
    } else {
      result = Super.apply(this, arguments)
    }
    return _possibleConstructorReturn(this, result)
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call
  }
  return _assertThisInitialized(self)
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    )
  }
  return self
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false
  if (Reflect.construct.sham) return false
  if (typeof Proxy === "function") return true
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}))
    return true
  } catch (e) {
    return false
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o)
      }
  return _getPrototypeOf(o)
}

var classNames = require("classnames")

var Button = /*#__PURE__*/ (function (_React$Component) {
  _inherits(Button, _React$Component)

  var _super = _createSuper(Button)

  function Button(props) {
    var _this

    _classCallCheck(this, Button)

    _this = _super.call(this, props)
    _this.state = {}
    return _this
  }

  _createClass(Button, [
    {
      key: "goBack",
      value: function goBack() {
        window.history.back()
      }
    },
    {
      key: "render",
      value: function render() {
        var btnClass = classNames("standard-button", this.props.className, {
          standalone: this.props.standalone,
          "go-back-button-top-left": this.props.goBack,
          white: this.props.white ? this.props.white : false,
          border: this.props.border ? this.props.border : false,
          minimal: this.props.minimal ? this.props.minimal : false,
          contained: this.props.contained ? this.props.contained : false
        })
        var backBtnClass = classNames("go-back-button", this.props.className, {
          "go-back-button": true,
          "go-back-button-top-left": this.props.goBack,
          white: this.props.white ? this.props.white : false,
          minimal: this.props.minimal ? this.props.minimal : false
        }) // for telephone links

        if (this.props.tel) {
          return /*#__PURE__*/ _react["default"].createElement(
            "a",
            {
              className: btnClass,
              href: this.props.href
            },
            this.props.buttonText
          )
        } // for external links

        if (this.props.external) {
          return /*#__PURE__*/ _react["default"].createElement(
            "a",
            {
              className: btnClass,
              href: this.props.href,
              target: "_blank",
              "aria-label": "open link in new browser tab",
              rel: "noopener noreferrer"
            },
            this.props.buttonText
          )
        } // for anchors DEPRECATED
        // if (this.props.anchor) {
        //   return (
        //     <a className={btnClass} href={this.props.href}>
        //       {this.props.buttonText}
        //     </a>
        //   )
        // }
        // for downloads

        if (this.props.download) {
          return /*#__PURE__*/ _react["default"].createElement(
            "a",
            {
              className: btnClass,
              href: this.props.href,
              target: "_blank",
              download: true
            },
            /*#__PURE__*/ _react["default"].createElement(
              _reactFontawesome.FontAwesomeIcon,
              {
                className: "button-icon",
                icon: _faFileDownload.faFileDownload
              }
            ),
            this.props.buttonText
          )
        } // Insert long left arrow for Back "Button"
        else if (this.props.goBack && !this.props.href) {
          return /*#__PURE__*/ _react["default"].createElement(
            "a",
            {
              className: backBtnClass,
              onClick: this.goBack
            },
            /*#__PURE__*/ _react["default"].createElement(
              _reactFontawesome.FontAwesomeIcon,
              {
                className: "button-icon",
                icon: _faLongArrowLeft.faLongArrowLeft
              }
            ),
            this.props.buttonText
          )
        } else if (this.props.goBack) {
          return /*#__PURE__*/ _react["default"].createElement(
            _gatsby.Link,
            {
              className: backBtnClass,
              to: this.props.href
            },
            /*#__PURE__*/ _react["default"].createElement(
              _reactFontawesome.FontAwesomeIcon,
              {
                className: "button-icon",
                icon: _faLongArrowLeft.faLongArrowLeft
              }
            ),
            this.props.buttonText
          )
        } // Classic Gatsby Link styled as a button; assumed to not be external
        else {
          if (!this.props.href)
            throw (
              "No href given to Button. Props are as follows: " +
              JSON.stringify(this.props)
            )
          var href = this.props.href
          if (href.charAt(0) !== "/") href = "/" + href
          return /*#__PURE__*/ _react["default"].createElement(
            _gatsby.Link,
            {
              className: btnClass,
              to: href
            },
            this.props.buttonText
          )
        }
      }
    }
  ])

  return Button
})(_react["default"].Component)

Button.propTypes = {
  standalone: _propTypes["default"].bool,
  anchor: _propTypes["default"].bool,
  minimal: _propTypes["default"].bool,
  white: _propTypes["default"].bool,
  border: _propTypes["default"].bool,
  contained: _propTypes["default"].bool,
  goBack: _propTypes["default"].bool,
  download: _propTypes["default"].bool,
  textAlign: _propTypes["default"].string,
  href: _propTypes["default"].string,
  buttonText: _propTypes["default"].string,
  className: _propTypes["default"].string
}
var _default = Button
exports["default"] = _default

//# sourceMappingURL=Button.js.map
